import { render, staticRenderFns } from "./InformationVerification.vue?vue&type=template&id=9bf27eb4&scoped=true"
import script from "./InformationVerification.vue?vue&type=script&lang=js"
export * from "./InformationVerification.vue?vue&type=script&lang=js"
import style0 from "./InformationVerification.vue?vue&type=style&index=0&id=9bf27eb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf27eb4",
  null
  
)

export default component.exports